import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const DroneImageUpload = ({ view, droneImages, index }) => {
    const [images, setImages] = useState([]);
    const [isPreview, setPreview] = useState(false)

    const formData = new FormData()

    const onDrop = (acceptedFiles) => {
        // Create an array to store the uploaded image files
        const uploadedImages = [];

        droneImages((prev) => [...prev, acceptedFiles[0]])
        // Loop through the accepted files and create a FileReader for each file
        acceptedFiles.forEach((file) => {
            const reader = new FileReader();
            //send formDate to global state

            // Read the file and add it to the uploadedImages array
            reader.onload = () => {
                uploadedImages.push(reader.result);
                setImages([...images, ...uploadedImages]);
                setPreview(true)
            };

            reader.readAsDataURL(file);
        });
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    return (
        <div className='flex flex-col h-full'>
            <h4 className='text-tblu pb-2 flex justify-between'>
                <span>{view} View</span>
                {isPreview && (
                    <button
                        onClick={() => {
                            setPreview(false);
                            setImages([]);
                            droneImages((prevImages) =>
                                prevImages.filter((_, i) => i !== index) // Remove the image at the specified index
                            );
                        }}
                    >
                        X
                    </button>
                )}
            </h4 >
            {!isPreview && <div {...getRootProps()} className={`dropzone border ${isDragActive && "border-tblu"} rounded-xl flex flex-grow justify-center items-center bg-zinc-100`}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p className='text-zinc-400'>Drop the files here...</p>
                ) : (
                    <div className="cta">
                        <p className='text-zinc-400 font-semibold'>Drag 'n' drop , or click to select files for {view} View</p>
                    </div>
                )}
            </div>}
            {
                images.length > 0 && (
                    <div className="image-preview">
                        {images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Preview ${index}`}
                                className="preview-image"
                            />
                        ))}
                    </div>
                )
            }
        </div >
    );
};

export default DroneImageUpload;
